import CloseIcon from "@mui/icons-material/Close";
import { saveAs } from "file-saver";
import React, { useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import PaginationTab from "../../../components/PaginationTab";
import SearchStaff from "../../../components/SearchStaff";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { HeaderSkeleton, PaginationSkeleton, TableSkeleton } from "./StaffTab";

const SalaryDetails = () => {
  const {
    staffs,
    fetchStaffs,
    fetchDepartments,
    isLoading,
    setSelectedStaff,
    setSelectedStaffIds,
    selectAll,
    setSelectAll,
    loadingStaffs
  } = useGlobalContext();

  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen((isOpen) => !isOpen);
  };

  const [toggleDrop, setToggleDrop] = useState(false);

  const dropdownRef = useRef(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const staffDropDown = useRef(null);

  const handleSelectAll = () => {
    if (selectAll) {
      // If already selected, clear all selections
      setSelectedStaffIds([]);
    } else {
      // Select all staff IDs
      const allStaffIds = staffs.map((staff) => staff.staffDetails.id);
      setSelectedStaffIds(allStaffIds);
    }
    setSelectAll(!selectAll);
  };


  function handledrop() {
    setToggleDrop(!toggleDrop);
  }
  const toggleDropdown = () => {
    setDropdownOpen((prev) => !prev);
  };


  useEffect(() => {
    if (staffs) {
      fetchStaffs();
      fetchDepartments();
    }
  }, []);



  const handleOutsideClick = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setDropdownOpen(false);
    }
    if (staffDropDown.current && !staffDropDown.current.contains(e.target)) {
      setToggleDrop(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  let subtitle;
  // toggle switch
  const [isOn, setIsOn] = useState(false);

  const handleToggle = () => {
    setIsOn(!isOn);
  };
  // toggle switch


  function handledrop() {
    setToggleDrop(!toggleDrop);
  }
  // when onclick update staff
  const [modalIsOpen9, setIsOpen9] = React.useState(false);
  function openModal9() {
    setIsOpen9(true);
  }
  function afterOpenModal9() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#000";
  }

  function closeModal9() {
    setIsOpen9(false);
  }
  // when onclick update staff

  const exportToCSV = () => {
    // Define CSV headers to match the table columns
    const headers = [
      "Index",
      "Name",
      "Job Title",
      "CTC",
      "Basic",
      "Employer PF Contribution",
      "Employer ESI Contribution",
      "EDLI & Admin Charges",
      "Employer LWF Contribution",
      "Employee PF",
      "Employee ESI",
      "Employee LWF",
      "Professional Tax",
    ];

    // Map over `staffDetail` to create rows with table data
    const rows = staffs?.map((item, index) => {
      const salaryDetail =
        item?.staffDetails?.SalaryDetails[
        item.staffDetails?.SalaryDetails?.length - 1
        ] || {};

      return [
        index + 1,
        item?.name || "N/A",
        item?.staffDetails?.job_title || "N/A",
        ` ${salaryDetail?.ctc_amount ?? "N/A"}`,
        "Basic", // Replace this if you have actual 'Basic' data
        ` ${salaryDetail?.employee_pf ?? "N/A"}`,
        ` ${salaryDetail?.employer_esi ?? "N/A"}`,
        "N/A", // Placeholder for EDLI & Admin Charges
        ` ${salaryDetail?.employer_lwf ?? "N/A"}`,
        ` ${salaryDetail?.employee_pf ?? "N/A"}`,
        ` ${salaryDetail?.employee_esi ?? "N/A"}`,
        ` ${salaryDetail?.tds ?? "N/A"}`,
        ` ${salaryDetail?.professional_tax ?? "N/A"}`, // Replace this if you have professional tax data
      ];
    });

    // Combine headers and rows for CSV format
    const csvData = [headers, ...rows].map((row) => row.join(",")).join("\n");

    // Create a Blob and initiate download
    const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "SalaryDetails.csv");
  };

  if (loadingStaffs && !staffs) {
    return (
      <div className="mt-[20px] staff-tab">
        <HeaderSkeleton />
        <TableSkeleton />
        <PaginationSkeleton />
      </div>
    );
  }

  return (
    <div className="mt-[20px] staff-tab">
      <div className="flex xl:flex-row flex-col md:flex-col lg:flex-col justify-between gap-[15px] lg:gap-[0px]">
        <div className="flex flex-wrap xl:flex-nowrap justify-between lg:justify-start gap-[15px] w-full">
          <SearchStaff dropdownRef={dropdownRef} setDropdownOpen={setDropdownOpen} toggleDropdown={toggleDropdown} isDropdownOpen={isDropdownOpen} />

          <button
            className="border-1 pt-2 pr-3 pb-2 pl-3 border rounded-md text-sm second-btn setwer"
            onClick={openModal9}
          >
            Update Staff Salary
          </button>
        </div>
      </div>

      <div className="flex border-1 shadow mt-4 p-0 border rounded-md w-[100%] h-[100%] overflow-scroll overflow-y-auto">
        <div className="w-full">
          <table className="w-full table-section">
            <thead className="border-1 border">
              <th>Name</th>
              <th>Job Title</th>
              <th>CTC</th>
              <th>Basic</th>
              <th>Employer PF Contribution </th>
              <th>Employer ESI Contribution</th>
              <th>EDLI & Admin Charges</th>
              <th>Employer LWF Contribution</th>
              <th>Employee PF</th>
              <th>Employee ESI</th>
              <th>Employee LWF</th>
              <th>Professional Tax</th>
            </thead>
            <tbody>

              {
                loadingStaffs && !staffs &&
                <tr className="h-[100px]">
                  <td
                    colSpan="11"
                    className="py-4 font-semibold text-center text-gray-600 text-xl"
                  >
                    <ClipLoader color="#27004a" size={50} />
                  </td>
                </tr>
              }

              {
                !loadingStaffs && staffs && staffs?.map((item, index) => {
                  const salaryDetail =
                    item?.staffDetails?.SalaryDetails?.[
                    item.staffDetails?.SalaryDetails?.length - 1
                    ];
                  return (
                    <tr className="border">
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        <Link
                          onClick={() => setSelectedStaff(item)}
                          to={`/salary-details-edit/${item?.staffDetails?.id}`}
                          className="font-medium text-[#8A25B0]"
                        >
                          {item?.name}
                        </Link>
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        {item?.staffDetails?.job_title}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        ₹ {salaryDetail?.ctc_amount ?? "N/A"}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        Basic
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        ₹ {salaryDetail?.employee_pf ?? "N/A"}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        ₹ {salaryDetail?.employer_esi ?? "N/A"}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        N/A
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        ₹ {salaryDetail?.employer_lwf ?? "N/A"}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        ₹ {salaryDetail?.employee_pf ?? "N/A"}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        ₹ {salaryDetail?.employee_esi ?? "N/A"}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        ₹ {salaryDetail?.tds ?? "N/A"}
                      </td>
                      <td className="border-[#dbdbdb] border-r whitespace-nowrap">
                        ₹ {salaryDetail?.employee_pf ?? "N/A"}
                      </td>
                    </tr>
                  );
                })
              }

              {
                !loadingStaffs && staffs && staffs?.length === 0 &&
                <tr>
                  <td
                    colSpan="11"
                    className="py-4 font-semibold text-center text-gray-600 text-xl"
                  >
                    No Client Found
                  </td>
                </tr>
              }

            </tbody>
          </table>
        </div>
      </div>

      <PaginationTab />

      {/* when onclick update staff */}

      <Modal
        isOpen={modalIsOpen9}
        onAfterOpen={afterOpenModal9}
        onRequestClose={closeModal9}
        // style={customStyles}
        contentLabel="Example Modal"
        className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"
      >
        <h2
          ref={(_subtitle) => (subtitle = _subtitle)}
          className="bg-[#F0F6FE] p-3 border-b rounded-b-none rounded-r-lg rounded-t-lg text-[14px] text-center"
        >
          Update Multiple Staff Salary
        </h2>
        <button
          onClick={closeModal9}
          className="top-[3px] right-[5px] absolute bg-[#511992] rounded-full font-semibold"
        >
          <CloseIcon className="text-white" />
        </button>
        <div className="pb-2">
          <p className="p-[10px] pr-[14px] pl-[14px] text-[12px] text-center">
            You need to setup your{" "}
            <Link to="/salary_Details" className="text-[#8A25B0]">
              Salary Details Import Settings.
            </Link>{" "}
            Only Earnings and Deductions set from Settings section can be
            updated through file upload.
          </p>

          <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
            <div className="flex items-center gap-[0px]">
              <h4 className="m-0 font-medium">
                Step 1. Download current salary of selected employees.
              </h4>
            </div>
            <div className="flex items-center">
              <button
                onClick={exportToCSV}
                className="p-1 rounded-md text-[13px] whitespace-nowrap outline-1 outline-dashed outline-offset-1"
              >
                Download Template
              </button>
            </div>
          </div>

          <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
            <div className=" ">
              <h4 className="m-0 font-medium">
                Step 2. Edit staff salary details.
              </h4>
              <p className="pt-2 pl-3 text-[10px] xl:text-[12px]">
                Please refer to instructions sheet in download template for
                formatting guide
              </p>
            </div>
          </div>

          <div className="flex justify-between items-center p-[10px] pl-[20px] border border-t-0 border-r-0 border-b border-l-0 text-[13px] xl:text-[14px]">
            <div className="flex items-center gap-[0px]">
              <h4 className="m-0 font-medium">
                Step 3.  Upload new Salary details
              </h4>
            </div>
            <div className="flex items-center">
              <button className="p-1 rounded-md text-[13px] outline-1 outline-dashed outline-offset-1">
                Upload Staff List
              </button>
              {/* <input type='file' placeholder='ddjfksj'/> */}
            </div>
          </div>
        </div>
      </Modal>
      {/* when onclick update staff
       */}
    </div>
  );
};

export default SalaryDetails;
